import { useState, useEffect, useRef } from "react";
import { TournamentItmResponse } from "../../../../../../../api/pub-tournament";
import { TournamentType } from "../../../../../../../dataset";
import { useRabbitFestivalContext } from "../../../../hooks/festival-context";
import Pagination from "../../../../../../../components/web/Pagination";
import {
  FestivalEventITMBack,
  FestivalEventITMHeader,
  FestivalEventITMItem,
  FestivalEventITMTable,
  FestivalEventITMWrapper,
} from "./style";

const RabbitFestivalEventITM = () => {
  const { event } = useRabbitFestivalContext();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [list, setList] = useState<TournamentItmResponse[]>([]);
  const [open, setOpen] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(open ? contentRef.current.scrollHeight + 56 + 20 : 56);
    }
  }, [open]);

  useEffect(() => {
    if (!event) return;
    setTotalPages(Math.max(1, Math.ceil(event.itm.length / 7)));
    setList(event.itm.slice((currentPage - 1) * 7, currentPage * 7));
  }, [event]);

  useEffect(() => {
    if (!event) return;
    setList(event.itm.slice((currentPage - 1) * 7, currentPage * 7));
  }, [currentPage]);

  const handelPrize = (item: TournamentItmResponse) => {
    if (event?.tournament.tournamentType === TournamentType.Tournament)
      return item.prize.toLocaleString();
    if (/^\d+$/.test(item.subPrize)) {
      return Number(item.subPrize).toLocaleString();
    }
    return item.subPrize;
  };

  return (
    <FestivalEventITMWrapper contentHeight={contentHeight}>
      <FestivalEventITMHeader onClick={() => setOpen(!open)} open={open}>
        <div className="title">ITM 순위</div>
        <img src="image-web/rabbit/down_arrow.svg" alt="more" />
      </FestivalEventITMHeader>
      <FestivalEventITMBack ref={contentRef} open={open}>
        <FestivalEventITMTable isHeight={totalPages > 1}>
          {list.map((item, index) => (
            <FestivalEventITMItem key={index}>
              <div className="user">
                <div className="rank">{item.rank}위</div>
                <div className="nickname">{item.nickname}</div>
              </div>
              <div className="point">{handelPrize(item)}</div>
            </FestivalEventITMItem>
          ))}
        </FestivalEventITMTable>
        {totalPages > 1 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
            size={22}
          />
        )}
      </FestivalEventITMBack>
    </FestivalEventITMWrapper>
  );
};

export default RabbitFestivalEventITM;
